import React, { useEffect, useRef } from "react";

export default function AffordabilityWidget({ amount, currency = "INR", keyId }) {
  const widgetRef = useRef(null);

  useEffect(() => {
    // Load Razorpay affordability widget script only once
    const scriptId = "razorpay-affordability-script";
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/affordability-widget.js";
      script.id = scriptId;
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (<>
   <div
      ref={widgetRef}
      className="razorpay-affordability-widget"
      data-key={keyId}
      data-amount={amount} // amount in paise
      data-currency={currency}
      data-display="inline"
    /></>
   
  );
}
